import { render } from "./audit-log-group.vue?vue&type=template&id=fd3aeb2a&scoped=true"
import script from "./audit-log-group.vue?vue&type=script&lang=js"
export * from "./audit-log-group.vue?vue&type=script&lang=js"

import "./audit-log-group.vue?vue&type=style&index=0&id=fd3aeb2a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd3aeb2a"]])

export default __exports__